import { useEffect, useRef } from 'react'

import { H } from 'highlight.run'

import { config } from '../../modules/app/config'
import { User } from '../../graphql/generated/graphql'

const init = () => {
    H.init(config.highlightProjectId, {
        environment: config.envName,
    })
}

export const useHighlight = () => {
    const initialized = useRef(false)
    useEffect(() => {
        if (initialized.current) return
        // init()
        initialized.current = true
    }, [])

    const identify = (user: User) => {
        H.identify(user.email, {
            id: user.id,
        })
    }

    return {
        identify,
    }
}
